import { useEffect, useState } from "react";

import { Button, Field, Input, Page, Panel, Stack, StatusBadge } from "@/components/ui";
import { accountAddress } from "@/lib/env";

import { Facts } from "../components/Text";

import { useHandleAvailability, useSetHandle } from "./lib/queries";
import { errorText } from "./lib/present";

/** The only screen an account holding an unchosen handle may reach (IDN-011). */
export function ChooseHandle() {
  const [typed, setTyped] = useState("");
  const wanted = typed.trim().toLowerCase();
  const setHandle = useSetHandle();

  /** The spelling to check: the typed one, a beat after the last keystroke. */
  const [settled, setSettled] = useState("");
  useEffect(() => {
    const timer = setTimeout(() => {
      setSettled(wanted);
    }, 350);
    return () => {
      clearTimeout(timer);
    };
  }, [wanted]);

  const availability = useHandleAvailability(settled);
  const checked = availability.data?.handle === wanted ? availability.data : undefined;
  const free = checked?.available === true;

  return (
    <Page title="Choose your handle">
      <Panel title="Handle" subtitle="This is the address you hand out. It is public.">
        <Stack gap={4}>
          <form
            className="cx-listbar"
            onSubmit={(event) => {
              event.preventDefault();
              setHandle.mutate(wanted);
            }}
          >
            <Field label="Handle">
              {({ id }) => (
                <Input
                  id={id}
                  mono
                  autoFocus
                  value={typed}
                  placeholder="handle"
                  onChange={(event) => {
                    setTyped(event.target.value);
                  }}
                />
              )}
            </Field>
            <Button
              type="submit"
              size="sm"
              loading={setHandle.isPending}
              disabled={wanted === "" || !free}
            >
              Claim
            </Button>
          </form>
          <Facts items={[{ label: "Address", value: accountAddress(wanted || "handle") }]} />
          <div aria-live="polite">
            {setHandle.isError ? (
              <StatusBadge tone="danger">{errorText(setHandle.error)}</StatusBadge>
            ) : checked === undefined ? null : free ? (
              <StatusBadge tone="success">Available</StatusBadge>
            ) : (
              <StatusBadge tone="danger">{checked.reason ?? "Taken"}</StatusBadge>
            )}
          </div>
        </Stack>
      </Panel>
    </Page>
  );
}
